<template>
  <div class="data-list-container vs-con-loading__container" id="order-item-list">
    <div
      slot="header"
      class="flex flex-wrap-reverse items-center flex-grow justify-between w-row mb-6"
    >
      <vs-button
        type="filled"
        class="gradient gradient-primary no-shadow add-new-responsive"
        icon-pack="feather"
        icon="icon-plus"
        @click="addNewItem"
      >Add New</vs-button>
      <div class="flex flex-wrap-reverse items-center flex-grow justify-end">
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer item-per-page-dropdown dropdown-responsive"
          style="width: 140px"
        >
          <div
            class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2 order-item-list-filter-name">{{filter.name}}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu style="width: 200px;">
            <vs-dropdown-item v-for="(item, i) in filterOptions" :key="i" @click="filter = item, filterCategory(item)">
              <span class="w-full flex justify-between" :class="{'text-primary': item.id == filter.id}">
                <span class="order-item-list-filter-name">{{item.name}}</span>
                <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="item.id == filter.id"/>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <div class="con-input-search vs-table--search ml-4 search-responsive">
          <input
            @input="searchItem"
            type="text"
            class="input-search vs-table--search-input rounded-item border-custom"
            placeholder="Name"
          />
          <i class="vs-icon notranslate icon-scale material-icons null">search</i>
        </div>
      </div>
    </div>
    <vs-table :data="item_list">
      <template slot="thead">
        <vs-th class="w-1/4" style="min-width: 150px">Item</vs-th>
        <vs-th class="w-1/4" style="min-width: 150px">Category</vs-th>
        <!-- <vs-th class="w-1/5">In Stock</vs-th> -->
        <vs-th class="w-1/6 center-title">Price</vs-th>
        <vs-th class="w-1/6 center-title">Action</vs-th>
        <vs-th class="w-1/6 center-title text-center">In stock</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td v-if="tr.item_variants.length <= 0"></vs-td>
          <vs-td :data="tr.name" @click.native="editItem(tr)" class="item-name">{{ tr.name }}</vs-td>
          <vs-td :data="tr.category_id" @click.native="editItem(tr)">{{ getNameByCateID(tr.category_id) }}</vs-td>
          <!-- <vs-td :data="tr.in_stock" class="pl-4" @click.native="editItem(tr)">{{ tr.in_stock }}</vs-td> -->
          <vs-td
            class="text-center"
            v-if="tr.item_variants[0] !== undefined"
            :data="tr.item_variants[0].price"
            @click.native="editItem(tr)"
          >{{ parseFloat(tr.item_variants[0].price).toFixed(2) }}</vs-td>
          <vs-td v-else></vs-td>
          <vs-td @click.native="editItem(tr)">
            <vs-row class="flex-center">
              <!-- <vs-button @click.stop="popupActive=true, itemDelete(tr)" type="filled" size="small" icon-pack="feather" icon="icon-trash" color="orange"></vs-button> -->
              <img src="../../assets/images/trash-icon.png" class="trash-icon" @click.stop="popupActive=true, itemDelete(tr)" />
            </vs-row>
          </vs-td>
          <vs-td @click.native="editItem(tr)">
              <div class="flex-center in-service-switch">
                <vs-switch v-model="tr.instock_status" v-on:click.stop="changeStatusInStock(tr)" />
              </div>
          </vs-td>
          <template class="expand-user" slot="expand" v-if="tr.item_variants.length > 0">
            <div class="flex flex-col" v-for="(item,i) in tr.item_variants" :key="i">
              <div class="flex justify-between border-top-custom bg-custom" :class="{'border-bottom-custom': i == tr.item_variants.length - 1}">
                <div class="w-1/2 variant-col" style="margin-left: 48px; max-width: 100%; white-space: normal; word-break: break-word; min-width: 300px;">
                  <span>{{ item.name }}</span>
                </div>
                <div class="w-1/2 variant-col" style="margin-left: 81px;">{{ parseFloat(item.price).toFixed(2) }}</div>
              </div>
            </div>
          </template>
          <!-- <template class="no-variant" slot="expand" v-else style="pointer-event: none">
              <div></div>
          </template>-->
        </vs-tr>
      </template>
    </vs-table>
    <div v-if="itemList._meta.pageCount">
      <!-- <vs-pagination class="mt-6 custom-pagination" :total="parseInt(rewardsData._meta.pageCount)" v-model="currentPage"
       @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination> -->
       <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(itemList._meta.pageCount)"
        :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
    </div>
    <add-order-item title_popup="Add item" :config="config" @close="closePopupAdd" type="add" @GoToLastPage="changePage(parseInt(itemList._meta.pageCount))"></add-order-item>
    <add-order-item
      title_popup="Item Detail"
      :config="detailConfig"
      v-if="detailConfig.item_info.id"
      :cateName="cateName"
      @close="closePopupDetail"
      type="detail"
      @GoToFirstPage="changePage(1)"
    ></add-order-item>
    <vs-popup class="holamundo delete-popup" title="Delete Item" :active.sync="popupActive">
      <div class="text-center">
        <h3>Do you want to delete item?</h3>
        <div class="flex flex-wrap items-center align-center p-6 justify-center">
          <vs-button class="mr-6 align-center delete-responsive" @click.native="deleteData">Delete</vs-button>
          <vs-button type="border" color="danger" class="cancel-responsive" @click="popupActive=false">Cancel</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import AddOrderItem from "./AddOrderItem.vue";
export default {
  name: "order-item-list",
  components: {
    "add-order-item": AddOrderItem
  },
  data() {

    return {
      cateName:{},
      // filterOptions: [
      //   { id: 1, title: "All Category", name: "all" },
      //   { id: 2, title: "New", name: "new" },
      //   { id: 3, title: "At risk", name: "atrisk" }
      // ],
      filterOptions: [{ id: -1, name: 'All category' }],
      filter: { id: -1, name: 'All category' },
      config: {
        isActive: false
      },
      detailConfig: {
        isActive: false,
        item_info: {}
      },
      modalKey: 0,
      add_type: false,
      update_type: false,
      popupActive: false,
      itemIdDelete: '',
      ITEM_STATUS_INSTOCK: 1,
      ITEM_STATUS_OUT_OF_STOCK: 3,
      currentPage: 1,
      itemsPerPage: 10,
      page_key: 0,
      search: '',
      action_type: '',
      isOpenLoading: false
    };
  },
  watch: {
    detailConfig: {
      immediate: true,
      deep: true,
      handler() {
        if(this.detailConfig.isActive) {
          this.update_type = true;
          document.body.classList.add('overflow-hidden');
        } else {
          this.update_type = false;
          if(!this.update_type && !this.add_type) {
            document.body.classList.remove('overflow-hidden');
          }
        }
      }
    },
    config: {
      immediate: true,
      deep: true,
      handler() {
        if(this.config.isActive) {
          this.add_type = true;
          document.body.classList.add('overflow-hidden');
        } else {
          this.add_type = false;
          if(!this.update_type && !this.add_type) {
            document.body.classList.remove('overflow-hidden');
          }
        }
      }
    },
  },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' item failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    searchItem({target}){
      // let tr_elems = document.querySelectorAll('tr');
      // tr_elems.forEach((elem) => {
      //   elem.classList.remove('tr-expandedx');
      // });

      // let tr_expand_elems = document.querySelectorAll('tr.tr-expand');
      // let count = 0;
      // if(tr_expand_elems) {
      //   tr_expand_elems.forEach((elem) => {
      //     if(elem && elem.parentNode && count == 0) {
      //       console.log(typeof(elem))
      //       console.log(elem.parentNode);
      //       count++;
      //       // elem.parentNode.removeChild(elem);
      //       // console.log(tr_expand_elems);
      //     }
      //   });
      // }
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.action_type = 'Search';
      if(!this.isOpenLoading){
        this.openLoadingInDiv();
      }
      this.timer = setTimeout(() => {
        this.search = target.value;
        const obj={
          page: 1,
          "per-page": this.itemsPerPage,
          name: target.value
        }
        if(this.filter.id != -1) {
          obj.category_id = this.filter.id;
        }
        this.$store.dispatch('item/ORDER_ITEM_LIST',obj).then(() => {
          this.closeLoading();
          let tr_elems = document.querySelectorAll('tr');
          tr_elems.forEach((elem) => {
            elem.classList.remove('tr-expandedx');
          });

          let tr_expand_elems = document.querySelectorAll('.tr-expand');
          if(tr_expand_elems) {

            tr_expand_elems.forEach((elem) => {
              if(elem && elem.parentNode) {
                elem.parentNode.removeChild(elem);
              }
            });
          }

          this.currentPage = 1;
        })
      }, 500);
    },
    changePage(currentPage){
      const obj = {
          page: currentPage,
          "per-page": this.itemsPerPage,
          name: this.search
      }
      if(this.filter.id != -1) {
        obj.category_id = this.filter.id;
      }

      this.action_type = 'Get list'
      this.openLoadingInDiv();
      this.$store.dispatch("item/ORDER_ITEM_LIST", obj).then(() => {
        this.closeLoading();
        this.page_key++;
        if(this.currentPage != currentPage) {
          let tr_elems = document.querySelectorAll('tr');
          tr_elems.forEach((elem) => {
            elem.classList.remove('tr-expandedx');
          });

          let tr_expand_elems = document.querySelectorAll('.tr-expand');
          if(tr_expand_elems) {

            tr_expand_elems.forEach((elem) => {
              if(elem && elem.parentNode) {
                elem.parentNode.removeChild(elem);
              }
            });
          }
        }
        this.currentPage = currentPage;
      })
    },
    filterCategory(item) {
      // if (this.timer) {
      //   clearTimeout(this.timer);
      //   this.timer = null;
      // }
      // let tr_elems = document.querySelectorAll('tr');
      // tr_elems.forEach((elem) => {
      //   elem.classList.remove('tr-expandedx');
      // });

      // let tr_expand_elems = document.querySelectorAll('.tr-expand');
      // if(tr_expand_elems) {
      //   tr_expand_elems.forEach((elem) => {
      //     if(elem && elem.parentNode) {
      //       elem.parentNode.removeChild(elem);
      //     }
      //   });
      // }
      this.action_type = 'Get list';
      if(!this.isOpenLoading){
        this.openLoadingInDiv();
      }

      // this.timer = setTimeout(() => {
        const obj = {
          page: 1,
          'per-page': this.itemsPerPage,
          name: this.search,
        }
        if(item.id != -1) {
          obj.category_id = item.id;
        }
        this.$store.dispatch('item/ORDER_ITEM_LIST',obj).then(() => {
          this.closeLoading();
          let tr_elems = document.querySelectorAll('tr');
          tr_elems.forEach((elem) => {
            elem.classList.remove('tr-expandedx');
          });

          let tr_expand_elems = document.querySelectorAll('.tr-expand');
          if(tr_expand_elems) {

            tr_expand_elems.forEach((elem) => {
              if(elem && elem.parentNode) {
                elem.parentNode.removeChild(elem);
              }
            });
          }

          this.currentPage = 1;
        })
      // }, 500);
    },
    itemDelete(tr){
      this.itemIdDelete = tr.id
    },
    deleteData(){
      const obj = {
        page: this.currentPage,
        "per-page": this.itemsPerPage,
        id: this.itemIdDelete
      }
      this.$store.dispatch("item/ORDER_ITEM_DELETE", obj).then(() => {
        this.$vs.notify({
            title: "Notification",
            text: "Delete item success!",
            color: "success",
            position: "top-right"
          });
      }).catch(() => {
         this.$vs.notify({
            title: "Notification",
            text: "Delete item failed!",
            color: "danger",
            position: "top-right"
          });
      })
      this.popupActive = false;
    },
    getNameByCateID(id){
      let name = '';
      for(let i = 0 ; i < this.categoryList.items.length ; i++){
        if(id == this.categoryList.items[i].id){
          name = this.categoryList.items[i].name;
        }
      }
      return name;
    },
    editItem(item) {
      this.detailConfig.isActive = true;
      this.detailConfig.item_info = item;
      this.modalKey++;
    },
    addNewItem() {
      this.config.isActive = true;
      this.modalKey++;
    },
    closePopupAdd() {
      this.add_type = false;
      this.config.isActive = false;
      this.detailConfig.item_info = {};
    },
    closePopupDetail() {
      this.update_type = false;
      this.detailConfig.isActive = false;
      this.detailConfig.item_info = {};
    },
    changeStatusInStock(item){
      const obj = {
        id: item.id,
        status: item.status == this.ITEM_STATUS_INSTOCK ? this.ITEM_STATUS_OUT_OF_STOCK : this.ITEM_STATUS_INSTOCK,
      }
      this.$store.dispatch('item/UPDATE_ITEM_INSTOCK_STATUS', obj).then(()=>{
         this.$vs.notify({
            title: "Updated",
            text: "Updated item instock success!",
            color: "success",
            position: "top-right"
          });
      }).catch(() => {
         this.$vs.notify({
            title: "Error",
            text: "Update item in stock failed!",
            color: "danger",
            position: "top-right"
          });
      });
    }
  },
  created() {
    const obj = {
      page: this.currentPage,
      "per-page": this.itemsPerPage,
    }
    this.$store.dispatch("item/ORDER_ITEM_LIST" , obj);
    this.$store.dispatch("category/LIST_CATEGORY").then(() => {
      let cate_list = this.$store.getters['category/categoryList'];
      let filterCate = [{ id: -1, name: 'All category' }];
      if(cate_list && cate_list.items) {
        for(let i = 0; i < cate_list.items.length; i++) {
          filterCate.push({
            id: cate_list.items[i].id,
            name: cate_list.items[i].name
          })
        }
        // console.log(filterCate);
        this.filterOptions = filterCate;
      }
    })
  },
  computed: {
    itemList(){
      return this.$store.state.item.itemList;
    },
    categoryList(){
      return this.$store.state.category.categoryList;
    },
    item_list() {
      return this.$store.getters["item/list"];
    }
  }
};
</script>